import { Component, OnInit } from '@angular/core';
import { AppSettingsService } from '../../../shared/services/appsettings.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';

import { AuthService } from '../../../shared/services/authentication.service';
import { NotificationService } from '../../../shared/services/notification.service';
import { TranslatorService } from '../../../core/translator/translator.service';

import { Router } from '@angular/router';
import { LoadingContainer, LoadingPage } from '../../../shared/LoadingContainer';

@Component({
    selector: 'app-login',
    template: require('./login.component.html'),
    styles: [require('./login.component.scss')],
    providers: [AuthService, NotificationService]
})
export class LoginComponent extends LoadingPage {

    valForm: FormGroup;

    constructor(
        public settings: AppSettingsService,
        fb: FormBuilder,
        protected authService: AuthService,
        protected notificationService: NotificationService,
        private translateService: TranslatorService,
        private router: Router
    ) {
        super(false);
        this.valForm = fb.group({
            'user': [null, Validators.compose([Validators.required])],
            'password': [null, Validators.required]
        });

    }

    OnInit() {
        // reset login status
        this.authService.logout();
    }

    submitForm($ev: Event, value: any) {
        this.standby();
        $ev.preventDefault();
        for (let c in this.valForm.controls) {
            this.valForm.controls[c].markAsTouched();
        }

        if (!this.valForm.valid) {
            this.ready();
            return;
        }

        let mail = this.valForm.get('user').value;
        let pass = btoa(this.valForm.get('password').value);
        this.authService.login(mail, pass)
            .then(response => {
                this.ready();
                this.notificationService.showSuccess('app.notification.SUCCESS', 'login.AUTH_SUCCESS');
                this.router.navigate(['/']);
            })
            .catch(e => {
                this.ready();
                this.notificationService.handleGlobalErrors(e);
            });
    }

    ngOnInit() {

    }

}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/routes/pages/login/login.component.ts